import { printLine, parseStyledString, waitForAnyKeyPress, stripFormattingCodes } from "../utilities.js";
import { commands, isSupportedCommand } from "../commands.js";
import { functions, isSupportedFunction } from "../functions.js";
import { variables, isSupportedVariable } from "../variables.js";
import { screen } from "../screen.js";

export const program = {
    name: "help",
    size: 173, // Number of lines of this 'program'
    list: async () => {
        await printLine("69 SYS 42590"); // Simulate the 'list' command when this program is loaded
    }, 
    run: async function () {
        await screen.clearScreen();
        await printLine();
        await printLine();
        await printLine();
        await printLine(parseStyledString("[fg=white]THIS SITE TRIES EMULATING A COMMODORE 64[/]"));
        await printLine();
        await printLine();
        await printLine();
        await printLine(parseStyledString("[fg=white]THE FOLLOWING IS A FULL LIST OF BASIC[/]"));
        await printLine(parseStyledString("[fg=white]KEYWORDS AND THEIR IMPLEMENTATION STATUS[/]"));
        await printLine();
        await printLine();
        await printLine();
        await printLine(parseStyledString("[fg=white]FOR MORE INFO, VISIT:[/]"));
        await printLine(parseStyledString("[fg=white]HTTPS://C64-WIKI.COM/WIKI/BASIC_V2[/]"));
        await printLine();
        await printLine();
        await printLine();
        await printLine();
        await printLine();
        await printLine();
        await printLine();
        await printLine();
        await printLine();
        await printLine();
        await waitForAnyKeyPress("white");
        await screen.clearScreen();
        await printLine(parseStyledString("[fg=white]########################################[/]"));
        await printLine(parseStyledString("[fg=white]#                                      #[/]"));
        await printLine(parseStyledString("[fg=white]#  BASIC KEYWORD  | IMPLEMENTED:[/][fg=green]YES[/][fg=white]/[/][fg=lightred]NO[/] [fg=white]#[/]"));
        await printLine(parseStyledString("[fg=white]#   ---------------------------------  #[/]"));
        
        // Loop through all commands and print them; if the command is not implemented, print it in red.
        let counter = 4;

        // Combine commands, functions, and variables into a single object for iteration.
        const allKeywords = { ...commands, ...functions, ...variables };
        // Order the keywords alphabetically.
        const sortedKeywords = Object.keys(allKeywords).sort();
        // Iterate through the sorted keywords and print each one.
        for (const keyword of sortedKeywords) {
            const line = this._getLine(keyword);
            await printLine(parseStyledString(line));
            counter++;
            // If 24 keywords have been printed, wait for a keypress.
            if (counter % 24 === 0) {
                await waitForAnyKeyPress("white");
            }
        }

        await printLine(parseStyledString("[fg=white]#   ---------------------------------  #[/]"));
        await printLine(parseStyledString("[fg=white]#                                      #[/]"));
        await printLine(parseStyledString("[fg=white]########################################[/]"));
    },

    _getLine(name) {
        const supported = isSupported(name);
        const color = supported ? "green" : "lightred";
        const desc = descriptions[name] || "";

        let line = `[fg=white]#[/]   [fg=${color}]${name.toUpperCase()}[/]`;
        let visibleLine = stripFormattingCodes(line);
        let paddingNeeded = 12 - visibleLine.length;
        if (paddingNeeded > 0) {
            line += " ".repeat(paddingNeeded);
        }
        line += `[fg=white]|[/] [fg=${color}]${desc}[/]`;

        visibleLine = stripFormattingCodes(line);
        paddingNeeded = 39 - visibleLine.length;
        if (paddingNeeded > 0) {
            line += " ".repeat(paddingNeeded);
        }
        line += "[fg=white]#[/]";
        return line;
    }
};

const isSupported = (name) => isSupportedCommand(name) || isSupportedFunction(name) || isSupportedVariable(name);

// 1234567890123456789012345678901234567890
// #   ---------------------------------  #
// #   1234567 | MAX 23 CHARACTERS        #
const descriptions = {
    "?": "COMMAND",
    ABS: "NUMERIC FUNCTION",
    AND: "BOOL/BITWISE OPERATOR",
    ASC: "NUMERICAL FUNCTION",
    ATN: "NUMERIC FUNCTION",
    CHR$: "STRING FUNCTION",
    CLOSE: "COMMAND",
    CLR: "COMMAND",
    CMD: "COMMAND",
    CONT: "COMMAND",
    COS: "NUMERIC FUNCTION",
    DATA: "COMMAND",
    DEF: "COMMAND",
    DIM: "COMMAND",
    END: "COMMAND",
    EXP: "NUMERIC FUNCTION",
    FN: "NUMERIC FUNCTION",
    FOR: "COMMAND",
    FRE: "FUNCTION",
    GET: "COMMAND",
    "GET#": "COMMAND",
    GOSUB: "COMMAND",
    GOTO: "COMMAND",
    IF: "COMMAND",
    INPUT: "COMMAND",
    "INPUT#": "COMMAND",
    INT: "INTEGER FUNCTION",
    LEFT$: "STRING FUNCTION",
    LEN: "NUMERIC FUNCTION",
    LET: "COMMAND",
    LIST: "COMMAND",
    LOAD: "COMMAND",
    LOG: "NUMERIC FUNCTION",
    MID$: "STRING FUNCTION",
    NEW: "COMMAND",
    NEXT: "COMMAND",
    NOT: "BOOL/BITWISE OPERATOR",
    ON: "COMMAND",
    OPEN: "COMMAND",
    OR: "BOOL/BITWISE OPERATOR",
    PEEK: "INTEGER FUNCTION",
    POKE: "COMMAND",
    POS: "INTEGER FUNCTION",
    PRINT: "COMMAND",
    "PRINT#": "COMMAND",
    READ: "COMMAND",
    REM: "COMMAND",
    RESTORE: "COMMAND",
    RETURN: "COMMAND",
    RIGHT$: "STRING FUNCTION",
    RND: "FUNCTION",
    RUN: "COMMAND",
    SAVE: "STATEMENT",
    SGN: "NUMERIC FUNCTION",
    SIN: "NUMERIC FUNCTION",
    SPC: "FUNCTION",
    SQR: "NUMERIC FUNCTION",
    ST: "SYSTEM VARIABLE",
    STATUS: "SYSTEM VARIABLE",
    STEP: "KEYWORD PART",
    STOP: "COMMAND",
    STR$: "STRING FUNCTION",
    SYS: "COMMAND",
    TAB: "FUNCTION",
    TAN: "NUMERIC FUNCTION",
    THEN: "KEYWORD PART",
    TI: "SYSTEM VARIABLE",
    TI$: "SYSTEM VARIABLE",
    TIME: "SYSTEM VARIABLE",
    TIME$: "SYSTEM VARIABLE",
    TO: "KEYWORD PART",
    USR: "FLOATING POINT FUNCTION",
    VAL: "NUMERIC FUNCTION",
    VERIFY: "COMMAND",
    WAIT: "COMMAND"
};